<template>
  <el-scrollbar>
    <el-form ref="ff" label-width="100px" label-position="top" :model="detail">
      <div class="toolbar" style="padding: 20px 0">
        <b>项目报备申请</b>
        <el-link
          type="primary"
          @click="
            $router.replace({ path: 'form' })
            detail = {}
          "
        >
          新表单
        </el-link>
      </div>
      <el-form-item label="采购单位" prop="Purchaser" required>
        <el-input v-model="detail.Purchaser" />
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="投标日期" prop="BidDate" required>
            <el-date-picker style="width: 100%" v-model="detail.BidDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报备截止" prop="DueDate" required>
            <el-date-picker
              style="width: 100%"
              v-model="detail.DueDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="{
                disabledDate(time) {
                  let firstDay = detail.CreateTime ? new Date(detail.CreateTime).getTime() : new Date().getTime()
                  let days = 35 * 24 * 3600 * 1000
                  let lastDay = firstDay + days
                  return time.getTime() < firstDay || time.getTime() > lastDay
                },
              }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报备金额" prop="Price" required>
            <el-input v-model="detail.Price" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最低价格">
            <el-input v-model="detail.MinPrice" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注信息">
        <el-input type="textarea" :rows="5" v-model="detail.Remarks" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" v-loading.fullscreen.lock="loading">提交</el-button>
      </el-form-item>
    </el-form>
  </el-scrollbar>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      detail: {},
    }
  },
  created () {
    this.$apis.project.enroll.detail({ id: this.$route.query.id }).then(res => {
      if (res != null) {
        res.DueDate = this.$utils.common.parseTime(res.DueDate)
        res.BidDate = this.$utils.common.parseTime(res.BidDate)
      }
      this.detail = res || {}
    })
  },
  methods: {
    //提交数据
    onSubmit () {
      this.$refs['ff'].validate(valid => {
        if (valid && !this.loading) {
          this.loading = true
          this.$apis.project.enroll.submit(this.detail).then(() => {
            this.$message({ message: "数据提交成功！", type: "success" })
            this.$router.push('pending')
          }).catch(e => {
            this.$message.error(e || "执行错误")
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  background: #fff;
  width: 640px;
  min-height: 100%;
  padding: 20px 40px;
}
</style>